export const account_delivery_info = 'account_delivery_info'
export const account_bank_info = 'account_bank_info'
export const anonymous_restriction = 'anonymous_restriction'
export const gamification_enabled = 'gamification_enabled'
export const lesson_enabled = 'lesson_enabled'
export const quiz_enabled = 'quiz_enabled'
export const masterclass_redirect_to_home = 'masterclass_redirect_to_home'
export const masterclass_chaining = 'masterclass_chaining'
export const subscription = 'subscription'
export const splash_screen_url = 'splash_screen_url'
export const show_splash_screen = 'show_splash_screen'
export const tasting_enabled = 'tasting_enabled'
export const tasting_save_feedback = 'tasting_save_feedback'
export const tasting_ask_create_account = 'tasting_ask_create_account'
export const tasting_redirect_tasting_list = 'tasting_redirect_tasting_list'
export const recommendations = 'recommendations'
export const social_media = 'social_media'
export const shop_url = 'shop_url'